import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      sign_up: 'Sign Up',
      email: 'Email',
      password: 'Password',
      confirm_password: 'Confirm Password',
      create_account: 'Create Account',
      already_have_account: 'Already have an account?',
      dont_have_account: "Don't have an account?",
      loading: 'Loading...',
      error: 'Error',
      reload: 'Reload',
      close: 'Close',
      home: 'Home',
      profile: 'Profile',
      menu: 'Menu',
      books: 'All Books',
      chapters: 'Chapters',
      chapter: 'Chapter',
      next_chapter: 'Next Chapter',
      previous_chapter: 'Previous Chapter',
      unlock_chapter: 'Unlock Chapter',
      coins: 'Coins',
      subscription: 'Subscription',
      purchase: 'Purchase',
      cancel: 'Cancel',
      confirm: 'Confirm',
      success: 'Success',
      failed: 'Failed',
      try_again: 'Try Again',
      no_books_found: 'No books found',
      chapter_label: 'Chapter {{number}}',
      chapter_count: '{{number}} chapters',
      read_count: '{{number}} reading',
      by_author: 'By {{author}}',
      by: 'By',
      continue_reading: 'Continue Reading',
      start_reading: 'Start Reading',
      all_chapters: 'All Chapters',
      add_to_favorites: 'Add to Favorites',
      remove_from_favorites: 'Remove from Favorites',
      reading_progress: 'Reading Progress',
      chapter_locked: 'Chapter Locked',
      unlock_with_coins: 'Unlock with {{coins}} coins',
      insufficient_coins: 'Insufficient coins',
      buy_coins: 'Buy Coins',
      get_subscription: 'Get Subscription',
      author_is_working: 'The author is still working on this chapter',
      chapter_not_finished: 'This chapter is not finished yet',
      go_to_book: 'Go to Book',
      chapter_next_free: 'Next chapter is free!',
      chapter_unlock_button: 'Unlock Chapter',
      chapter_free_chapter_notified: 'Notify me',
      chapter_notification_added: 'Notification added',
      notification_free_chapter_reason:
        'Get notified when free chapter is available',

      passwords_dont_match: 'Passwords do not match',
      password_min_length: 'Password must be at least 6 characters',
      sign_up_failed: 'Sign up failed',
      login_failed: 'Sign in failed',
      authentication_failed: 'Authentication failed',
      account_already_exists: 'An account with this email already exists',
      invalid_email: 'Please enter a valid email address',

      theme_light: 'Light',
      theme_dark: 'Dark',
      theme_toggle: 'Toggle Theme',
      theme: 'Theme',

      app_name: 'NanoReads',

      error_generic: 'An error occurred. Please try again.',
      error_network: 'Network error. Please check your connection.',
      error_server: 'Server error. Please try again later.',

      support: 'Support',
      contact_support: 'Contact Support',
      contact_support_description:
        'Get help with your account or report issues',
      sign_out: 'Sign Out',
      download: 'Download',
      download_app: 'Download App',
      get_the_app: 'Get the app',
      read_offline: 'Read your favorite books offline',
      free_chapters: 'free chapters',
      download_nanoreads_app: 'Download NanoReads App',
      every_8_hours: 'every 8 hours on mobile app',
      read_free_chapters: 'Read',
      download_on_app_store: 'Download on App Store',
      download_on_google_play: 'Download on Google Play',
      login_to_continue: 'Sign in to continue reading',
      create_free_account:
        'Create a free account to unlock this chapter and continue your reading journey.',
      unlock_with_coins_count: 'Unlock Chapter ({{coins}} coins)',
      auto_unlock_chapters: 'Auto-unlock chapters',
      chapter_requires_coins:
        'This chapter requires {{coins}} coins to unlock.',
      continue_reading_description: 'Find out what happens next in the story.',

      complete_your_purchase: 'Complete Your Purchase',
      create_account_to_continue: 'Create an Account to Continue',
      registration_failed: 'Registration failed',
      email_required: 'Email is required',
      create_account_and_continue: 'Create Account & Continue',
      registration_successful: 'Registration Successful!',
      account_created_successfully:
        'Your account has been created successfully.',
      redirecting_to_your_books: 'Redirecting you to your books...',
      redirecting_to_chapter: 'Redirecting to your chapter...',

      continue_reading_book_browser: 'Continue reading book in your browser',
      click_three_dots_instruction_android:
        'Click the three dots icon in the right corner',
      click_share_instruction_ios: 'Click the Share icon',
      click_open_chrome_android: 'Click "Open in Chrome"',
      click_open_safari_ios: 'Click "Open in Safari"',
      share: 'Share',
      open_chrome: 'Open in Chrome',
      open_safari: 'Open in Safari',
      continue_reading_here: 'Continue Reading Here',
      questions_contact_support: 'Questions? Contact NanoReads support at',
      show_password: 'Show password',
      hide_password: 'Hide password',

      login: 'Login',
      tropes: 'Tropes',
      privacy_policy: 'Privacy Policy',
      terms_of_service: 'Terms of Service',
      weekly: 'Weekly',
      yearly: 'Yearly',
      processing: 'Processing...',
      claim_the_offer: 'Claim the offer',
      creating_account: 'Creating Account...',
      password_required: 'Password is required',
      unknown_error: 'Unknown error',
      purchase_failed: 'Purchase failed',
      failed_to_load_books: 'Failed to load books',
      failed_to_toggle_favorite: 'Failed to toggle favorite',
      failed_to_load_chapter: 'Failed to load chapter',
      failed_to_unlock_chapter: 'Failed to unlock chapter',
      purchase_failed_generic: 'Purchase failed',
      discount_purchase_failed: 'Discount purchase failed',
      coin_purchase_failed: 'Coin purchase failed',
      subscription_purchase_failed: 'Subscription purchase failed',
      guest_coin_purchase_failed: 'Guest coin purchase failed',

      // New translations for hardcoded strings
      font_decrease: 'A-',
      font_increase: 'A+',
      of: 'of',
      readers: 'readers',
      book_ended: "You've reached the end of this book!",
      more_chapters_soon: 'More chapters coming soon!',
      you_have_coins: 'You have {{coins}} coins',
      purchase_successful: 'Purchase Successful!',
      create_account_save_purchase:
        'Create your account to save your purchase and access your content',
      email_address: 'Email Address',
      at_least_6_characters: 'At least 6 characters',
      confirm_your_password: 'Confirm your password',
      enter_your_email: 'Enter your email',
      creating_your_account: 'Creating your account...',
      by_creating_account: 'By creating an account, you agree to our',
      and: 'and',
      terms_conditions: 'Terms & Conditions',
      expires_in: 'Expires in:',
      first_week_discount: 'First Week Discount',
      discount_40_off: '-40% off for weekly subscription',
      price_first_week: '$ 4,99 / first week',
      processing_purchase: 'Processing your purchase...',
      unlimited_reading: 'Unlimited reading',
      buy_chapters: 'Buy Chapters',
      subscribe_unlimited_access:
        'Subscribe to Enjoy Unlimited Access to All Books',
      unlimited_access_books: 'Unlimited access to all books',
      new_chapters_monthly: '1000 new chapters every month',
      comfortable_mobile_app: 'Comfortable mobile app',
      cancel_anytime: 'Cancel anytime',
      buy_coins_unlock: 'Buy coins to unlock chapters',
      recommended: 'RECOMMENDED',
      bonus: 'bonus',
      coins_dont_expire:
        "Purchased Coins don't expire and can be used to unlock chapters",
      buy_now: 'Buy now',
      get_full_access_yearly: 'Get full access for {{price}}/year',
      get_full_access_weekly: 'Get full access for {{price}}/week',
      money_back_guarantee: '24-hour money-back guarantee',
      coins_per_chapter: '30 coins per chapter',
      settings: 'Settings',
      manage_subscription: 'Manage Subscription',
      manage_subscription_description:
        'Update payment method, cancel, or view billing history',
      download_on: 'Download on',
      app_store: 'App Store',
      google_play: 'Google Play',

      unsubscribe_email_title: 'Unsubscribe from Email Campaigns',
      unsubscribe_email_description:
        "We're sorry to see you go! If you no longer wish to receive our emails, you can unsubscribe below.",
      unsubscribe_email_note:
        "You'll still be able to enjoy all the books in the app.",
      unsubscribe_email_address: 'Email: {{email}}',
      unsubscribe_from_emails: 'Unsubscribe from Emails',
      unsubscribe_confirmation_title: 'Are you sure?',
      unsubscribe_confirmation_email: 'Unsubscribing email: {{email}}',
      unsubscribe_confirmation_message:
        "You'll no longer receive reminders about books you're reading.",
      unsubscribe_confirmation_note: 'Are you sure you want to unsubscribe?',
      yes_unsubscribe: 'Yes, Unsubscribe',
      no_keep_emails: 'No, Keep Emails',
      unsubscribe_success_title: 'Successfully Unsubscribed',
      unsubscribe_success_description:
        'You have been unsubscribed from NanoReads email campaigns',
      unsubscribe_success_message:
        "You have been successfully unsubscribed from our email campaigns. You won't receive any more marketing emails from us.",
      unsubscribe_email_confirmed: 'Email {{email}} has been unsubscribed.',
      unsubscribe_app_access_message:
        'You can still enjoy all the books in the NanoReads app. Happy reading! 📚',
      return_to_nanoreads: 'Return to NanoReads',
      need_help: 'Need help?',
      invalid_unsubscribe_link:
        'Invalid unsubscribe link. Please use the link from your email.',
      invalid_unsubscribe_token: 'Invalid unsubscribe token',
      unsubscribe_failed: 'Failed to unsubscribe. Please try again.',
      reading: 'Reading',
      ratings: 'Ratings',

      in_progress: 'In progress',
      author_preparing_chapters:
        'The author is preparing next {{count}} chapters',
      book_ready_in: 'The chapters will be ready in',
      discover_similar_books: 'Discover similar books',
      notify_me: 'Notify me',
      notification_added_success:
        'You will be notified when new chapters are available',
      failed_to_add_notification: 'Failed to add notification',
      adding_notification: 'Adding notification...',
      sign_in_required: 'Please sign in to receive notifications',

      do_you_want_to_read_on_mobile_app:
        'Do you want to read on the mobile app?',
      click_below_to_download_nanoreads_mobile_app:
        'Click below to download NanoReads mobile app',
      skip: 'Skip',
      questions_contact_nanoreads_support_at:
        'Questions? Contact NanoReads support at',
      continue_to_mobile_app_prompt: 'Continuing to mobile app prompt...',

      // SEO Meta Tags
      app_description:
        'Read unlimited romance books and novels with NanoReads. Discover your next favorite book today.',
      app_keywords:
        'romance books, novels, reading app, ebooks, stories, unlimited reading',
      home_title: 'Unlimited Romance Books',
      home_description:
        'Discover thousands of romance books and novels. Start reading your favorite stories today with NanoReads.',
      home_keywords:
        'romance books, novels, reading, ebooks, stories, book library',
      profile_description:
        'Manage your NanoReads account settings, subscription, and reading preferences.',
      sign_up_description:
        'Create your free NanoReads account to start reading unlimited romance books and novels.',
      login_description:
        'Sign in to your NanoReads account to continue reading your favorite books.',
      chapter_title: 'Chapter {{chapter}} - {{book}}',
      chapter_description:
        'Read Chapter {{chapter}} of {{book}} on NanoReads. Continue your reading journey.',
      purchase_finalize_title: 'Complete Your Purchase',
      purchase_finalize_description:
        'Complete your NanoReads purchase and start reading unlimited books.',
      registration_successful_description:
        'Your NanoReads account has been created successfully. Welcome to unlimited reading!',
      mobile_app_download_title: 'Download NanoReads Mobile App',
      mobile_app_download_description:
        'Get the best reading experience with the NanoReads mobile app. Read anywhere, anytime.',
      exit_browser_title: 'Continue Reading',
      exit_browser_description:
        'Continue reading your favorite books in your browser or download our mobile app.',
      complete_purchase_description:
        'Create your account to complete your purchase and unlock unlimited reading.',

      home_headline: 'Top Billionaire Romance books to read now',
      home_tagline: 'Short, addictive Billionaire stories.',

      read_now: 'Read Now',
      similar_stories: 'Similar stories',
      book_description_default:
        'Discover this captivating romance story filled with passion, drama, and unforgettable characters.',
      book_title_default: 'Romance Story',
      book_keywords_default: 'romance, billionaire, love story, passion, drama',
      chapter_description_default:
        'Read {{chapterNumber}} of {{bookTitle}} on NanoReads. Continue your reading journey with this captivating romance story.',

      // New translations for hub pages and components
      reads: 'reads',
      no_image: 'No Image',
      billionaire_romance_tropes: 'Billionaire Romance Tropes',
      explore_billionaire_romance_categories:
        'Explore billionaire romance categories - from CEO office affairs to dark tycoon secrets. Find your perfect billionaire love story.',

      // 404 Page translations
      page_not_found: 'Page Not Found',
      page_not_found_title: 'Page Not Found - 404 Error',
      page_not_found_description:
        'The page you are looking for could not be found. Discover our romance books and stories instead.',
      page_not_found_message:
        'Sorry, the page you are looking for could not be found. It may have been moved, deleted, or you entered the wrong URL.',
      back_to_home: 'Back to Home',
      go_back: 'Go Back',
      explore_books: 'Explore Books',
      popular_books: 'Popular Books',
      book_not_found: 'Book Not Found',
      chapter_not_found: 'Chapter Not Found',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export { i18n };
